import React, { useEffect, useState } from 'react';
import { FaCalendarCheck, FaQuestion, FaMoon, FaRunning, FaToggleOff, FaToggleOn, FaHamsa } from "react-icons/fa";
import { format } from 'date-fns';
import Sched from './Sched';

const Scheds = () => {
  const [curNow, setNow] = useState(null);
  // const [refreshInterval, setRefreshInterval] = useState(500000);
  const [data, setData] = useState(null);
  // auto-refresh
  const refreshHome = () => {
    // update time
    try {
      // setNow(format(new Date().toLocaleString(), 'eee HH:mm:ss'));
    } catch (error) {

    }
  }

  useEffect(() => {
    // fetch(`https://10007.cherry2024.com:2096/getservers`)
    //   .then(response => response.json())
    //   .then(data => setData(data))
    //   .catch(error => console.error(error));

    // if (refreshInterval && refreshInterval > 0) {
    //   const interval = setInterval(refreshHome, refreshInterval);
    //   return () => clearInterval(interval);
    // }
  },);

  return (
    <div className="container topLine3">
      <div className="row">
        <div className="col-sm-12">
          <div className="container">
            <div className="row">
              <span className="col-sm-6">
                <Sched
                  farmno={1}
                  farmname={"Onsite"}
                />
              </span>
              <span className="col-sm-6">
                <Sched
                  farmno={2}
                  farmname={"Limitless"}
                />
              </span>
            </div>
            <div className="row">
              <span className="col-sm-6">
                <Sched
                  farmno={4}
                  farmname={"Dolphin"}
                />
              </span>
              <span className="col-sm-6">
                <Sched
                  farmno={5}
                  farmname={"Spanish"}
                />
              </span>
            </div>
            <div className="row">
              <span className="col-sm-12">
                &nbsp;
                <div className="padit align-items-center justify-content-center border border-info detailhdr">
                  Date Symbols: <br></br>&nbsp;
                  <span className="calon justify-content-center runningman shorttext col-sm-3">
                    < FaRunning />&nbsp;=&nbsp;ON
                  </span> &nbsp;
                  <span className=" caloff justify-content-center runningman shorttext col-sm-3">
                    < FaMoon />&nbsp;=&nbsp;OFF
                  </span> &nbsp;
                  <span className=" calnite justify-content-center runningman shorttext col-sm-3">
                    <FaHamsa />&nbsp;=&nbsp;Night
                  </span>

                  <br></br>
                  <span className="calnot justify-content-center runningman shorttext col-sm-6">
                    < FaQuestion />&nbsp;=&nbsp;NO&nbsp;SCHEDULE
                  </span>
                </div>
                <div className="padit align-items-center justify-content-center border border-info detailhdr">
                  <FaCalendarCheck />&nbsp;This is a rolling 3 month calendar always starting on today.<br></br>
                  <FaCalendarCheck />&nbsp;Clicking on a date toggles it thru on / off / night.<br></br>
                  <FaCalendarCheck />&nbsp;Click on a < FaQuestion /> = NO SCHEDULE&nbsp;
                  day to set the robot to run on that date. This is how you add new dates to the schedule for a farm.<br></br>
                  <FaCalendarCheck />&nbsp;If today has NO SCHEDULE, the bot will run on a fixed Mon-Sun schedule.<br></br>
                  <FaCalendarCheck />&nbsp;Robots start at 5am and stop at 9pm on regular
                  <span className="calon justify-content-center runningman shorttext col-sm-3">
                    < FaRunning />&nbsp;=&nbsp;ON
                  </span> days.&nbsp;
                  &nbsp;<span className=" calnite justify-content-center runningman shorttext col-sm-3">
                    <FaHamsa />&nbsp;=&nbsp;Night
                  </span> starts at 6pm and ends at 9pm.<br></br>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default Scheds;
